import CandidateMangComp from "../../components/CandidateManagement/CandidateMandComp";

const CandidateManagement = () => {
  return (
    <>
      <CandidateMangComp />
    </>
  );
};

export default CandidateManagement;
